import { Pipe, PipeTransform } from '@angular/core';
    @Pipe({
      name: 'stringToJson'
    })
    export class CatelogueCustomPipe implements PipeTransform {
      transform(value: string): any {
        try {
            if (!value.startsWith("[")) {return '';}
            //const jsonObject = JSON.parse(value);
            
          //   let added_feature:string[]=[];
          //   for (let key in jsonObject)
          //   {
          //       added_feature.push(jsonObject[key]["column_name"]);
          //   }

          // return added_feature.join(",")
          let addedFeaturesList:any[] = JSON.parse(value);
          return addedFeaturesList.map(feature => feature.column_name).join(',');
        
        } catch (error) {
          console.error('Error parsing JSON string:', error);
          return '';
        }
      }
    }